/**************************************************
 * Nombre:       Formulario_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {LocalOfferOutlined} from "@mui/icons-material";
import Tarjeta_Sub_Categorias from "../Tarjetas/Tarjeta_Sub_Categorias";
import {useIngresarObjeto} from "../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Sub_Categoria from "./Formulario_Sub_Categoria";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoImagen from "../../Modulo_formularios/Componentes/IngresoImagen";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";

const Formulario_Categoria = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        nombre: 'Sub Categoria',
        dato: 'subCat',
        props: props,
        Formulario: Formulario_Sub_Categoria,
        Tarjeta: Tarjeta_Sub_Categorias
    })
    const [subCategorias,setSubCategorias] = useState([])


    useEffect(() => {
        obtenerCol('subCategorias').then((dox) =>{
            if (dox.res){
                setSubCategorias(dox.data.map((it) => it.nombre).sort())
            }
        })
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid2
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop
                                  dato={'img'} {...props}

                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={LocalOfferOutlined} nombre={'Nombre de la categoria'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Sub Categorias que la componen</Typography>
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresarObjeto opciones={subCategorias} />
                </Grid2>


            </Grid2>

        </form>

    )

}
export default Formulario_Categoria